export default __webpack_public_path__ + "static/media/google.83bde142.svg";